import { useCallback } from 'react';

import { skipToken, useApolloClient, useQuery } from '@apollo/client/react';

import { HAS_LOGISTICS_CHANNEL } from './graphql';

interface LogisticPermissionControlLazy {
  lazy?: false;
  skip?: boolean;
  storeId: string | null;
}

interface LogisticPermissionControl {
  lazy?: true;
  skip?: false;
  storeId?: string | null;
}

interface HookReturnType {
  hasLogisticsChannel: boolean;
  error: unknown;
  loading: boolean;
  fetchHasLogisticsChannel: (storeId?: string | null) => Promise<{
    hasLogisticsChannel: boolean;
  }>;
}

function useStoreLogisticPermissionsCode(params: LogisticPermissionControlLazy): HookReturnType;
function useStoreLogisticPermissionsCode(params: LogisticPermissionControl): HookReturnType;
function useStoreLogisticPermissionsCode({
  lazy = false,
  skip = false,
  storeId = null,
}: LogisticPermissionControlLazy | LogisticPermissionControl): ReturnType<
  typeof useStoreHasLogisticChannel
> {
  const client = useApolloClient();
  const { data, error, loading } = useQuery(
    HAS_LOGISTICS_CHANNEL,
    !skip && !lazy
      ? {
          variables: { storeId },
        }
      : skipToken
  );

  const fetchHasLogisticsChannel = useCallback(
    async (storeId?: string | null) => {
      const { data: result } = await client.query({
        query: HAS_LOGISTICS_CHANNEL,
        variables: {
          storeId: storeId,
        },
      });
      return {
        hasLogisticsChannel: result?.hasLogisticsChannel.boolean ?? false,
      };
    },
    [client]
  );

  const hasLogisticsChannel = data?.hasLogisticsChannel.boolean ?? false;

  return {
    hasLogisticsChannel,
    error,
    loading,
    fetchHasLogisticsChannel,
  };
}

export const useStoreHasLogisticChannel = useStoreLogisticPermissionsCode;
